import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EventService {
  private logoutSubject = new Subject<void>();
  logout$ = this.logoutSubject.asObservable();

  emitLogout() {
    console.log("emitting logout");
    this.logoutSubject.next();
  }
}
